import AbstractSessionModel from '../../../models/AbstractSessionModel';
import Observable from '../../../decorators/Observable';
import Action from '../../../decorators/Action';
import StoreFieldInSession from '../../../decorators/StoreFieldInSession';
import FinalizeSitemapWizardData from './FinalizeSitemapWizardData';
import { IWizardDataModel } from '../../../models/IWizardDataModel';
import WizardSessionData from '../../../services/WizardSessionData';

class FinalizeSitemapModel
  extends AbstractSessionModel
  implements IWizardDataModel
{
  @Observable()
  @StoreFieldInSession()
  public importantPages: { id: string | number; pageName: string }[] = [];

  @Observable()
  @StoreFieldInSession()
  public isTreeDisabled = false;

  @Observable()
  public finalizeSitemapWizardData = new FinalizeSitemapWizardData();

  constructor() {
    super();
    super.initFields();
  }

  @Action()
  setImportantPages(
    importantPages: { id: string | number; pageName: string }[]
  ) {
    this.importantPages = importantPages;
  }

  @Action()
  addImportantPage(importantPage: { id: string | number; pageName: string }) {
    if (this.importantPages.some((page) => page.id === importantPage.id)) {
      return;
    }

    // add in the last position of the array
    this.importantPages.push(importantPage);

    if (this.importantPages.length >= 4) {
      this.isTreeDisabled = true;
    } else {
      this.isTreeDisabled = false;
    }
  }

  @Action()
  removeImportantPage(id: string | number) {
    this.importantPages = this.importantPages.filter((page) => page.id !== id);

    if (this.importantPages.length < 4) {
      this.isTreeDisabled = false;
    }
  }

  isPageDisabledForSelection(id: string | number) {
    if (this.isTreeDisabled === false) {
      return false;
    }

    if (this.importantPages.find((page) => page.id === id)) {
      return false;
    }

    return true;
  }

  getWizardData() {
    return this.finalizeSitemapWizardData.getWizardData();
  }

  public getSessionKey(): string {
    return 'FinalizeSitemapModel';
  }
}

const model = new FinalizeSitemapModel();
WizardSessionData.addModel(model);
export default model;
